import { FileExtendedDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { clientError } from 'sos-common/js/commonTypes/ClientError.types';

export const API_ENDPOINT_FRIVILLIG = '/_api/ombudsansokan/frivillig';
export const API_ENDPOINT_REQUIRED = '/_api/ombudsansokan/required';

export interface OmbudCompletionProps {
  isRequiredCompletion?: boolean;
  expandHeading: string;
  expandIcon?: string;
  expandCssClass?: string;
  fileHeading: string;
  innerHeading?: string;
  innerParagraph?: string;
  ombudId: string;
  documentList?: OmbudCompletionDocumentListItem[];
  complementaryId?: string;
}

export interface OmbudCompletionState {
  unlockSendButton: boolean;
  fileUploadState: FileExtendedDetails[];
  serverResponseObject: PostFilesServerResponseObject;
  complementaryId: string;
  clientError: clientError;
  showDialog: boolean;
  sendSuccess: boolean;
  sendCompletionErrorMessage: string;
}

export interface OmbudCompletionDocumentListItem {
  fileName: string;
  url: string;
  fileExtension: string;
  fileId: string;
}

export interface GetAttachmentsServerResponseObject {
  Files: ServerResponseFile[];
  ComplementaryId: string;
}

export interface ServerResponseFile {
  filnamn: string;
  id: string;
  mimeType: string;
  storlek: number;
  tidpunkt: string;
}

export interface PostFilesServerResponseObject {
  FileId: string;
  ComplementaryId: string;
  OriginalFilename: string;
}
